import { render, staticRenderFns } from "./service-advantage.vue?vue&type=template&id=30e2d105&scoped=true&"
import script from "./service-advantage.vue?vue&type=script&lang=js&"
export * from "./service-advantage.vue?vue&type=script&lang=js&"
import style0 from "./service-advantage.vue?vue&type=style&index=0&id=30e2d105&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e2d105",
  null
  
)

export default component.exports